import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ocilistfile',
  templateUrl: './ocilistfile.component.html',
  styleUrls: ['./ocilistfile.component.css']
})
export class OCilistfileComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


  requestData = 
  `
  curl 'https://api.optimusdrive.ai/v1/oci/files?path=VideoForOptimizer/' \
  -H 'authorization: XXX'
  
  `

  sucessData = 
  `{
    "data": {
        "files": [
            {
                "type": "file",
                "path": "VideoForOptimizer/sample2.mp4",
                "name": "300_FPS_Video_transcoded.mp4",
                "size": 19360140,
                "last_modified": "2023-07-06 07:33:43.423 +0000 UTC"
            },
            {
                "type": "file",
                "path": "VideoForOptimizer/Video_sample1.mp4",
                "name": "5_FPS_Video_transcoded.mp4",
                "size": 1756450,
                "last_modified": "2023-07-06 07:35:51.812 +0000 UTC"
            }
        ],
        "cursor": ""
    },
    "message": "Files fetched successfully"
}`


  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `

  Error4x = `
  {
    "error": "Get \"https://objectstorage.us-east-2.oraclecloud.com/n/axuoklajukje/b/cmw-test-video-bucket/o?delimiter=%2F&fields=name%2CtimeCreated%2Csize%2CtimeModified&prefix=\": dial tcp: lookup objectstorage.us-east-2.oraclecloud.com on 169.254.78.1:53: no such host",
    "message": "Unable to fetch object"
  }
  
  `

  Error42x = `
  {
    "error": "unable to generate token",
    "message": "Something went wrong!"
  }`



  Error401x = `
  {
    "error": {},
    "message": "Unauthorized"
  }
  `



}
